import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchUser } from "../actions";
import InterviewList from "./interview_list";
import FooterSendMessageButton from "./footer_send_message_button";
import ProfileContainer from "../containers/profile_container";
import InvestmentContainer from "../containers/investment_container";
import CareerContainer from "../containers/career_container";
import AboutContainer from "../containers/about_container";

class App extends Component {
  componentDidMount() {
    const { user_name, fetchUser } = this.props;
    fetchUser(user_name);
  }

  render () {
    const { user } = this.props;

    return user.hasOwnProperty("name") && (
      <React.Fragment>
        <ProfileContainer />

        <div className='container user-profile'>
          <InterviewList {...user} {...this.props} />
          <InvestmentContainer />
          <CareerContainer />
          <AboutContainer />
        </div>

        <FooterSendMessageButton {...user} />
      </React.Fragment>
    );
  }
}

App.propTypes = {
  user_name: PropTypes.string.isRequired,
  fetchUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    user_name: PropTypes.string.isRequired,
    defaultUserImage: PropTypes.string.isRequired,
    defaultCompanyImage: PropTypes.string.isRequired,
    blogUrl: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  user: Object.assign(state.user, ownProps)
});

const mapDispatchToProps = dispatch => ({
  fetchUser: (name) => dispatch(fetchUser(name))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
